var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-table-container"},_vm._l((_vm.userColumns),function(userColumn){return _c('ProfileTableItem',{key:userColumn.id,staticClass:"item",attrs:{"user-column":userColumn}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }